import { render, staticRenderFns } from "./SuggestionForImprovement.vue?vue&type=template&id=2832a4e6&scoped=true&"
import script from "./SuggestionForImprovement.vue?vue&type=script&lang=js&"
export * from "./SuggestionForImprovement.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionForImprovement.vue?vue&type=style&index=0&id=2832a4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832a4e6",
  null
  
)

export default component.exports